	<template>

	<div class="content">
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-12">
						<h4 class="card-title mt-0">Lançamentos</h4>
						<span class="subtitle f-14">Veja aqui todos movimentos financeiros realizados.</span>
					</div>
					<div class="col-12 col-sm-12 col-md-5 text-center-mobile">
						<template v-if="!month">
				            <span style="margin-left: 0px;"><b>Período de</b></span>
				            <input type="date" class="form-control d-inline ml-3" style="max-width: 160px; border-radius: 5px; min-height: 40px" v-model="data_inicio">
				            <span style="margin-left: 10px; margin-right: 10px"><b>até</b></span>
				            <input type="date" class="form-control d-inline" style="max-width: 160px; border-radius: 5px; min-height: 40px" v-model="data_fim">
							<button class="btn btn-primary ml-2" @click="reload()">Filtrar</button>
							<button class="btn btn-primary ml-2" @click="changeDateFormat()">X</button>
						</template>

						<template v-if="month">
							<button class="btn btn-primary text-grey" @click="prev()">
								<i class="now-ui-icons arrows-1_minimal-left text-white"></i>
							</button>
							
							<button class="btn btn-primary" @click="changeDateFormat()">
								<span class="only-mobile">{{ data_inicio | moment('MMM/Y')}}</span>
								<span class="hidden-mobile">{{ data_inicio | moment('MMMM/Y')}}</span>
							</button>

							
							<button class="btn btn-primary text-grey" @click="next()">
								<i class="now-ui-icons arrows-1_minimal-right text-white"></i>
							</button>
						</template>
					</div>

					<div class="col-12 col-sm-12 col-md-7 text-center-mobile">
						<button class="btn btn-primary float-right-lg" @click="income()">
							<span class="only-mobile">+</span><span class="hidden-mobile">NOVA</span> RECEITA
						</button>
						<button class="btn btn-danger ml-2 float-right-lg" @click="expense()">
							<span class="only-mobile">+</span><span class="hidden-mobile">NOVA</span> DESPESA
						</button>
						<button class="btn btn-transparente float-right-lg ml-2" title="Nova Transferência" @click="handleTransferencia()">
							<i class="fa fa-refresh"></i>
						</button>
					</div>
					<div class="col-7 hidden-mobile">
						<button class="btn btn-primary" :class="{ 'opaque': type != 'o' }" @click="changeType('o')">
							Todos
						</button>
						<button class="btn btn-primary" :class="{ 'opaque': type != 'e' }" @click="changeType('e')">
							Despesas
						</button>
						<button class="btn btn-primary " :class="{ 'opaque': type != 'r' }" @click="changeType('r')">
							Receitas
						</button>
					</div>

					<div class="col-12 col-md-5 text-right text-center-mobile">
						<button class="btn btn-transparente" @click="exportarExcel">Exportar Excel <i class="fa fa-file-excel-o"></i></button>
					</div>

					<div class="col-12 col-md-8 text-center-mobile">
						<select class="btn btn-transparente" @change="reload()" v-model="typeState" style="display: inline-block;">
							<option value="caixa">Caixa</option>
							<option value="competencia">Competência</option>
						</select>
						<select class="btn btn-transparente" @change="reload()" v-model="account_id" style="display: inline-block; width: 200px;">
							<option value="">Todas as contas</option>
							<option v-for="account of accounts" :value="account.id">{{ account.name }}</option>
						</select>

						<select class="btn btn-transparente hidden-mobile" @change="reload()" v-model="cliente_id" style="display: inline-block; width: 200px;">
							<option value="">Todos os clientes</option>
							<option v-for="cliente of clientes" :value="cliente.codigo">{{ cliente.nome_razao }}</option>
						</select>
						<select class="btn btn-transparente hidden-mobile" @change="reload()" v-model="fornecedor_id" style="display: inline-block; width: 200px;">
							<option value="">Todos os fornecedores</option>
							<option v-for="fornecedor of fornecedores" :value="fornecedor.codigo">{{ fornecedor.razao_nome }}</option>
						</select>
					</div>
					<div class="col-12 col-md-4 text-right text-center-mobile" style="font-size: 28px;">
						Saldo: <span :class="{ 'text-success': options.saldo >= 0, 'text-danger': options.saldo < 0 }">{{ options.saldo | currencyBrl(true) }}</span>
					</div>
				</div>

				<loading v-bind:isLoading="isLoading"></loading>

				<div class="row only-mobile p-2 order-mobile" @click="editOrder(order)"  v-for="(order, index) in sortedItems" :key="index">
					<div class="col-6">
						{{ order.shown_date | moment('DD/MM/YYYY') }}<br>
						<span class="text-grey">{{ order.category_name }}</span>
					</div>
					<div class="col-6 text-right">
						<div class="text-expense" v-if="isExpense(order)"> - {{ order.value | currencyBrl(true) }} </div>
						<div class="text-revenue" v-if="isRevenue(order)"> {{ order.value | currencyBrl(true) }} </div>

							<span :class="getOrderToggleColor(order)">{{ getOrderToggleName(order) }}</span>
							<i v-if="order.is_overdue && !order.pay_date" class="fa fa-clock-o text-warning	"></i>
							<i v-if="!order.pay_date && !order.is_overdue" class="fa fa-clock-o text-muted"></i>
							<i v-if="order.pay_date" class="fa fa-check text-success"></i>
					</div>
				</div>


				<table class="table table-hover table-md f-14 hidden-mobile">
					<thead class="thead-default">
						<tr>
							<th>DATA</th>
							<th>DESCRIÇÃO</th>
							<th class="hidden-sm-down">CATEGORIA</th>
							<th class="hidden-xs-down"></th>
							<th class="text-right">VALOR</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(order, index) in sortedItems" :key="index">
							<td class="pointer text-blue" @click="editOrder(order)"><a>{{ order.shown_date | moment('DD/MM/YYYY') }}</a></td>
							<td>{{ order.name }}</td>
							<td class="hidden-sm-down">{{ order.category_name }}</td>
							<td class="hidden-xs-down pointer" @click="togglePayDate(order)">
								<span :class="getOrderToggleColor(order)">{{ getOrderToggleName(order) }}</span>
								<i v-if="order.is_overdue && !order.pay_date" class="fa fa-clock-o text-warning	"></i>
								<i v-if="!order.pay_date && !order.is_overdue" class="fa fa-clock-o text-muted"></i>
								<i v-if="order.pay_date" class="fa fa-check text-success"></i>
							</td>
							<td class="text-right">
								<div class="text-expense" v-if="isExpense(order)"> - {{ order.value | currencyBrl(true) }} </div>
								<div class="text-revenue" v-if="isRevenue(order)"> {{ order.value | currencyBrl(true)}} </div>
							</td>
						</tr>

						<tr v-if="sortedItems && sortedItems.length == 0">
							<td class="text-center" colspan="9">
								<span v-if="!isLoading">Nenhum registro no período</span>
								<span v-if="isLoading">Carregando...</span>
							</td>
						</tr>
					</tbody>
				</table>


				<order-form-component @change="reload"></order-form-component>
				<transferencia-form-component @change="reload"></transferencia-form-component>
			</div>

			<div class="bg-grey py-3 px-3">
				<div class="row">
					<div class="col-md-4 col-sm-12 hidden-xs-down f-14">
						<p>Resumo do período ({{ options.start }} - {{ options.end }})</p>
						<p>Total de transações: {{ options.order_count }}</p>
						<div class="row mt-1 mb-2" style="border-top: 1px solid #ddd"></div>

						<template v-if="type == 'o'">
							<p>Receitas Pendentes: {{ options.pending_revenue_count }}  <span class="float-right"> {{ options.pending_revenue_total | currencyBrl}} </span></p>
							<p>Despesas Pendentes: {{ options.pending_expense_count }}  <span class="float-right">- {{ options.pending_expense_total | currencyBrl}}</span></p> 
						</template>
						
						<template v-if="type == 'r'">
							<p>Receitas Liquidadas: {{ options.paid_revenue_count }}  <span class="float-right"> {{ options.paid_revenue_total | currencyBrl}} </span></p>
							<p>Receitas Pendentes: {{ options.pending_revenue_count }}  <span class="float-right"> {{ options.pending_revenue_total | currencyBrl}} </span></p>
						</template>

						<template v-if="type == 'e'">
							<p>Despesas Liquidadas: {{ options.paid_expense_count }}  <span class="float-right">- {{ options.paid_expense_total | currencyBrl}}</span></p>
							<p>Despesas Pendentes: {{ options.pending_expense_count }}  <span class="float-right">- {{ options.pending_expense_total | currencyBrl}}</span></p> 
							
						</template>


					</div>
					<div class="col-md-4 offset-md-4 col-sm-12">

						<div class="row mr-2">
							<div class="col-md-5 text-right">
								<p>Total de receitas</p>
							</div>
							<div class="col-md-7 text-right">
								<p class="f-22 text-green">{{ options.order_revenue_total | currencyBrl}}</p>
							</div>
						</div>

						<div class="row mr-2">
							<div class="col-md-5 text-right">
								<p>Total de despesas</p>
							</div>
							<div class="col-md-7 text-right">
								<p class="f-22 text-red">- {{ options.order_expense_total | currencyBrl}}</p>
							</div>
						</div>

						<div class="row mt-2 mb-2" style="border-top: 1px solid #ddd"></div>

						<div class="row mr-2">
							<div class="col-md-5 text-right">
								<p>Total do período</p>
							</div>
							<div class="col-md-7 text-right">
								<p class="text-green f-22" v-if="options.order_total >= 0">{{ options.order_total | currencyBrl}}</p>
								<p class="text-red f-22" v-if="options.order_total < 0">{{ options.order_total | currencyBrl}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>
</template>

<script>
	import OrderFormComponent  from './Order/OrderFormComponent'
	import TransferenciaFormComponent  from './Order/TransferenciaFormComponent'
	import Order from '@/models/Order'
	import Loading from '@/components/Loading'
	import OrderService from '@/services/OrderService'
	import AccountService from '@/services/AccountService'
	import ClienteService from '@/services/ClienteService.js'
	import FornecedorService from '@/services/FornecedorService.js'
	import moment from 'moment'

	export default {
		components: {
			OrderFormComponent,
			TransferenciaFormComponent,
			Loading
		},
		computed: {
			sortedItems: function() {
			    return this.orders.sort((a, b) => new Date(a.shown_date) - new Date(b.shown_date))
			}
		},
		data() {
			return {
				params: "",
				orders: [],
				options: {},
				type: 'o',
				typeState: 'caixa',
				data_inicio: moment().startOf('month').format('YYYY-MM-DD'),
				data_fim: moment().endOf('month').format('YYYY-MM-DD'),
				isLoading: false,
				month: true,
				accounts: [],
				clientes: [],
				fornecedores: [],
				account_id: "",
				cliente_id: "",
				fornecedor_id: "",
			}
		},
		methods: {
			exportarExcel() {
				var a = document.createElement("a");
				document.body.appendChild(a);
				a.style = "display: none";
	            a.href = process.env.VUE_APP_API_URL + 'orders/export/excel' + this.params + "&token=" + localStorage.getItem('token');
	            a.target= "_blank";
	            a.click();
			},
			prev() {
				this.data_inicio = moment(this.data_inicio).subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
				this.data_fim = moment(this.data_fim).subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
				this.reload()
			},
			next() {
				this.data_inicio = moment(this.data_inicio).add(1, 'month').startOf('month').format('YYYY-MM-DD')
				this.data_fim = moment(this.data_fim).add(1, 'month').endOf('month').format('YYYY-MM-DD')
				this.reload()
			},
			expense() {
				this.showDialog(new Order({ type: 'e' }))
			},
			income() {
				this.showDialog(new Order({ type: 'r' }))
			},
			showDialog(order) {
		        this.$modal.show('order-form-component', { order })
			},
			showTransferenciaDialog() {
		        this.$modal.show('transferencia-form-component')
			},
			isRevenue(order) {
				return OrderService.isRevenue(order)
			},
			isExpense(order) {
				return OrderService.isExpense(order)
			},
			loadOptions() {
				let params = '?type=' + this.type + '&state=' + this.typeState + "&start=" + this.data_inicio + "&end=" + this.data_fim

				if(this.account_id) {
					params += '&account_id=' + this.account_id
				}

				if(this.fornecedor_id) {
					params += `&fornecedor_id=${this.fornecedor_id}`
				}

				if(this.cliente_id) {
					params += `&cliente_id=${this.cliente_id}`
				}

				OrderService.options(params).then(res => {
					this.options = res.data
					this.$forceUpdate();
				})
				.catch(err => {

				})
			},
			changeDateFormat() {
				this.month = !this.month;
				
				if(this.month) {
					this.data_inicio = moment().startOf('month').format('YYYY-MM-DD')
					this.data_fim = moment().endOf('month').format('YYYY-MM-DD')
					this.reload()
				}
			},
			changeTypeState(typeState) {
				this.typeState = typeState
				this.reload()
			},
			handleTransferencia() {
				this.showTransferenciaDialog()
			},
			changeType(type) {
				this.type = type;
				this.reload()
			},
			loadOrders() {
				this.isLoading = true;
				this.params = '?type=' + this.type + '&state=' + this.typeState + "&start=" + this.data_inicio + "&end=" + this.data_fim

				if(this.fornecedor_id) {
					this.params += `&fornecedor_id=${this.fornecedor_id}`
				}

				if(this.cliente_id) {
					this.params += `&cliente_id=${this.cliente_id}`
				}

				if(this.account_id) {
					this.params += '&account_id=' + this.account_id
				}

				OrderService.load(this.params).then(res => {
					this.isLoading = false;

					let orders = []

					for(let order of res.data) {
						order.shown_date = this.getDate(order)
					}

					this.orders = res.data
					this.$forceUpdate();
				})
				.catch(err => {
					this.isLoading = false;
				})
			},
			getOrderToggleName(order) {
				if(this.isExpense(order)) {
					if(order.pay_date) {
						return 'Pago';
					}
					return 'Pagar'
				} else {
					if(order.pay_date) {
						return 'Recebido';
					}

					return 'Receber'
				}
			},
			getOrderToggleColor(order) {
				if(this.isExpense(order)) {
					if(order.pay_date) {
						return 'text-success pr-1';
					}


					if(order.is_overdue) {
						return 'text-warning pr-1'
					}

					return 'text-muted pr-1'
				} else {
					if(order.pay_date) {
						return 'text-success pr-1';
					}

					if(order.is_overdue) {
						return 'text-warning pr-1'
					}

					return 'text-muted pr-1'
				}
			},
			togglePayDate(order) {
				if(order.pay_date) {
					this.editOrder(order)
				} else {
					OrderService.pay(order).then(res => {
						order = res.data
						this.reload()
					})
					.catch(err =>{

					})
				}
			},
			editOrder(order) {
		        this.$modal.show('order-form-component', { order })
			},
			loadAccounts() {
				AccountService.load().then(res => {
					this.accounts = res.data
				})
				.catch(err => {
					console.error(err)
				})
			},
			reload() {
				this.loadAccounts()
				this.loadOrders()
				this.loadOptions()
			},
			getDate(order) {
				if(this.typeState == 'caixa') {
					if(order.pay_date) {
						return order.pay_date
					} else {
						return order.due_date
					}
				} else {
					return order.competence
				}
			},
			loadClientes() {
				ClienteService.load(`?no_paginate=true`).then(res => {
					this.clientes = res.data
				})
			},
			loadFornecedores() {
				FornecedorService.load(``).then(res => {
					this.fornecedores = res.data
				})
			}
		},
		mounted() {
			this.loadClientes()
			this.loadFornecedores()
			this.reload()
		}
	}
</script>

<style>
.table-action-bar {
	padding-bottom: 20px;
	margin-top: 20px;
}

.table-action-bar-left {
	float: left;
	margin-bottom: 15px;
}

.table-action-bar-right {
	float: right;
	margin-bottom: 15px;
}

.col-check {
	max-width: 30px;
	margin-left: 0;
	margin-right: 0;
	padding-left: 0;
	padding-right: 0;
}

.col-check input {
	max-width: 30px;
	padding: 0;
	margin: 0;
}

.date-filter {
	width: 560px;
	padding: 3px 24px;
}


.float-right-lg {
	float: right;
}

@media (max-width: 600px) {
	.date-filter {
		width: auto;

	}

	.float-right-lg {
		float: none;
	}
}

.order-grey {
	color: #ccc;
}

.order-green {
	color: green;
}

.order-mobile {
	border-top: 1px solid #ddd;
}

.btn-transparente {
	background-color: #fefefe !important;
	color: #999 !important;
	border: 1px solid #ccc !important;
}

.btn-transparente:first-child {
	color: black;
}

</style>